import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import { StatusCode } from "react-http-status-code";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { isWhiteLabel } from 'utils/whiteLabel';
import PteMaxNav from 'components/Frontend/PteMax/PteMaxNav';
import PteMaxFooter from 'components/Frontend/PteMax/PteMaxFooter';

class About extends React.Component {
    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('197333187452630');
        // ReactPixel.pageView();
    }

    render() {
        const whiteLabel = isWhiteLabel();

        const body = (
            <div className="content innerPage notFound">
                <section className="bannerOuter"></section>
                <section className="pageContent text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <img src="/images/404-img.jpg" alt="Page not found" />
                                <div className="mt-5">
                                    {whiteLabel ? (
                                        <p>
                                            Page not found. <a href="/auth/login">Go to login</a>.
                                        </p>
                                    ) : (
                                        <p>
                                            Uh oh, we can't seem to find the page you're looking for. Try going back to <a href="/">home page</a> or see contact us <a href="/contact">here</a> for more information.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );

        return (
            <StatusCode code={404}>
                <React.Fragment>
                    {whiteLabel ? <PteMaxNav /> : <Header />}
                    {body}
                    {whiteLabel ? <PteMaxFooter /> : <Footer />}
                </React.Fragment>
            </StatusCode>
        );
    }
}

export default About;
